import { CHANNEL, VISIBILITY } from 'constants/ChatConstants';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../../actionTypes';

/**
 * @typedef {Array<string>} CountByTypeInternalReducer
 */
const initialState = [];

/**
 *
 * @param {CountByTypeInternalReducer} _
 * @param {import('modules/chat/types').FetchUnreadCountsByTypeSuccessAction} action
 * @returns {CountByTypeInternalReducer}
 */
const update = (_, { payload }) => payload.internal;

/**
 * @param {CountByTypeInternalReducer} state
 * @param {import('modules/sockets/types/actions').PutSocketMessageAction & { payload: {  message: import('modules/chat/types/message').Message }  }} action
 * @returns {CountByTypeInternalReducer}
 */
const updateFromNewMessage = (state, { payload }) => {
  const { message } = payload;
  return !state.includes(message.conversationId) &&
    message.channel === CHANNEL.INTERNAL &&
    message.visibility === VISIBILITY.PRIVATE
    ? [...state, message.conversationId]
    : state;
};

export default createReducer(initialState, {
  [actionTypes.FETCH_UNREAD_COUNTS_BY_TYPE_SUCCESS]: update,
  [actionTypes.RECEIVE_MESSAGE_FROM_SOCKET]: updateFromNewMessage,
});
